import { css } from "styled-components";
const applyStyles = (config) => {
    const { minWidth, observedElementWidth, styles } = config;
    if (observedElementWidth === undefined) {
        // Fallback to browser media query
        return css `
      @media all and (min-width: ${minWidth}px) {
        ${styles};
      }
    `;
    }
    if (observedElementWidth >= minWidth) {
        return styles;
    }
    return "";
};
export const atMinWidth = (minWidth, styleBlock) => (props) => {
    const { observedElementWidth } = props;
    if (Array.isArray(minWidth)) {
        return css `
        ${minWidth.map(([minWidth, styles]) => applyStyles({ minWidth, styles, observedElementWidth }))}
      `;
    }
    return applyStyles({
        observedElementWidth,
        minWidth,
        styles: styleBlock
    });
};
